/* Libraries */
import styled from 'styled-components';
/* Utils */
import {device} from 'utils/media';

const InstagramContainer = styled.div`
  max-width: 500px;
  display: block;
  margin: 0 auto;
`;

export default InstagramContainer;



// WEBPACK FOOTER //
// ./src/components/ArticleContent/InstagramContainer.js